// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/productivity-settings", // changed
  Short: "/pyr/standard-quantities/short",
  Detail: "/pyr/standard-quantities",
  Create: "/pyr/standard-quantities",
  Update: "/pyr/standard-quantities",
  Delete: "/pyr/standard-quantities",
  Sync: "/pyr/productivity-settings/sync", // add new not follow previous pattern
};
